module.exports = __webpack_public_path__ + "img/bosspack-active.6ba940bd.svg";